export enum InsertOrderErrorCodeEnum {
    NoError = 0,
    IsFraudError = 9,
    FraudError101 = 101,
    FraudError102 = 102,
    FraudError103 = 103,
    FraudErrorDisposableEmail = 106,
    FraudError200 = 200,
    CreditPackError = 13,
    IsEligibleWCSSBSError = 14,
}